<template>
	<div class="home" v-show="ready">
		<div class="wrapper">
			<div class="cover page" v-show="pageNum==1">
				<div class="scene">
					<!-- <img class="logo" src="../img/logo.png"> -->
					<img class="title" src="../img/titleImg.png">
					<img class="years" src="../img/years.png">
					<img class="wine" src="../img/wine.png">
					<div class="startBtn">
						<div class="closed" @click="opener()">
							<img v-show="envelope" class="closed" src="../img/envelope1.png" >
							<img class="finger" v-show="envelope" src="../img/finger.png">
						</div>
						
						<div v-show="!envelope" class="opened">
							<img preload="auto" class="envelope3" src="../img/envelope3.png">
							<img preload="auto" class="paper" src="../img/paper.png">
							<img class="envelope2" src="../img/envelope2.png">
						</div>
					</div>
				</div>
				<img class="logo" src="../img/logo1.png">
				<div class="tips" @touchstart="onTouchStart" @touchmove="onTouchMove" @touchend="onTouchEnd"></div>
			</div>

			<div class="catalogue page" v-show="pageNum == 2">
				<div class="scene">
					<!-- <img class="logo" src="../img/logo2.png"> -->
					<div class="content">
						<img class="bauble" src="../img/pen.png">
						<div class="imgBox" ref="myElement" v-on:scroll="scrollHandler">
							<img class="letter" src="../img/letter.png">

						</div>
						<span class="shadow"></span>
					</div>
				</div>
				<img class="logo" src="../img/logo1.png">
				<div class="tips"  @touchstart="onTouchStart" @touchmove="onTouchMove" @touchend="onTouchEnd"></div>
			</div>
			<div class="tel page" v-show="pageNum == 3">
				<audio src="../video/telphone1.mp3" loop class="telphone1" id="telphone1" preload="auto"></audio>
				<audio src="../video/telphone2.mp3" class="telphone2" id="telphone2" preload="auto"></audio>
				<div class="scene">
					<!-- <div class="render">
						<p></p>
					</div> -->
					<div class="content">
						<div class="videoBox">
							<video src="../video/video.mp4" ref="video" preload="auto" poster="../img/poster.jpg"  webkit-playsinline playsinline></video>
						</div>
					</div>
					<img class="signal" src="../img/signal.png" >
					<img class="phone animateTada" src="../img/phone.png" @click="videoPlay()">

				</div>
				<img class="logo" src="../img/logo1.png">
				<div class="tips"  @touchstart="onTouchStart" @touchmove="onTouchMove" @touchend="onTouchEnd"></div>
			</div>
			<div class="tencent page" v-show="pageNum == 4">
				<audio src="../video/qq1.mp3" class="qqmusic1" preload="auto" id="qqmusic1"></audio>
				<audio src="../video/qq2.mp3" class="qqmusic2" preload="auto" id="qqmusic2"></audio>
				<audio src="../video/bg3.mp3" class="bgmusic3" preload="auto" id="bgmusic3" loop></audio>
				<div class="scene">
					<div class="messageTips" v-if="message" @click="receive()">
						<img class="message" src="../img/message.png">
						<img class="finger1" src="../img/finger1.png">
					</div>

					<div class="content" v-show="!message">
						<div class="qqBox" ref="QQmessage">
							<img class="message1" src="../img/message1.png">
							<img class="message2" src="../img/message2.png">
							<img class="message3" src="../img/message3.png" @click="showLayer(0)">
							<img class="message4" src="../img/message4.png" @click="showLayer(1)">
							<img class="message5" src="../img/message5.png" @click="showLayer(2)">
							<img class="message6" src="../img/message6.png" @click="showLayer(3)">
							<img class="message7" src="../img/message7.png" @click="showLayer(4)">
							<img class="message8" src="../img/message8.png" @click="showLayer(5)">
							<img class="message9" src="../img/message9.png" @click="showLayer(6)">
							<img class="message10" src="../img/message10.png">
						</div>
						<div class="shadow"></div>
					</div>
				</div>
				<img class="logo" src="../img/logo1.png">
				<div class="tips"  @touchstart="onTouchStart" @touchmove="onTouchMove" @touchend="onTouchEnd"></div>
			</div>
			<div class="redBook page" v-show="pageNum == 5">
				<audio src="../video/bg4.mp3" class="bgmusic4" preload="auto" id="bgmusic4" loop></audio>
				<div class="scene">
					<img class="bgRB" src="../img/bgRB.png" alt="redBook">
					<div class="redContent">
						<div class="swiper" ref="swiper">
							<!-- <swiper :slides-per-view="3" :space-between="50" @swiper="onSwiper" @slideChange="onSlideChange"
								:direction='vertical' :autoplay="true">
								<swiper-slide v-for="item in swiperDate" :key="item">
									<div class="swiperImg">
										<img class="mugeda_render_object" :src="item.img">
									</div>
									<div class="swiperText">{{ item.text }}</div>
								</swiper-slide>
							</swiper> -->
							<div class="swiper-wrapper">
								<div class="swiper-slide" v-for="(item , index) in swiperDate" :key="index">
									<div class="swiperImg">
										<div class="imgBox">
											<img class="item" :src="item">
										</div>
									</div>

								</div>
							</div>
							<!-- 如果需要分页器 -->
							<div class="swiper-pagination"></div>
						</div>
					</div>
				</div>
				<img class="logo" src="../img/logo1.png">
				<div class="tips"  @touchstart="onTouchStart" @touchmove="onTouchMove" @touchend="onTouchEnd" ></div>
			</div>
			<div class="ended page" v-show="pageNum==6">
				<div class="scene">
					<img class="title" src="../img/titleImg2.png">
					<img class="years" src="../img/years.png">
					<img class="wine" src="../img/wine.png">
				</div>
				<img class="logo" src="../img/logo1.png">
			</div>

			<div class="layer" @click="close()" v-show="layer">
				<div class="inner">
					<img :src="largeImg" alt="img">
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import COVER from "@/utils/COVER";
import { Swiper, SwiperSlide } from 'swiper/swiper-bundle.min'
import 'swiper/swiper-bundle.css'
import DialogComponent from "@/components/Dialog";
import { mapState,  mapActions } from "vuex";
import { set } from "nprogress";

export default {
  	name: "home",
  	data() {
    	return {
			isShowRule: false,
			pageNum: 1,
			startX: 0, // 触摸开始时的横坐标
			startY: 0, // 触摸开始时的纵坐标
			endX: 0, // 触摸结束时的横坐标
			endY: 0, // 触摸结束时的纵坐标     
			swiperDate: [
				require("../img/slide1.jpg"), require("../img/slide2.jpg"), require("../img/slide3.jpg"), require("../img/slide4.jpg"), require("../img/slide5.jpg"), require("../img/slide6.jpg"), require("../img/slide7.jpg"), require("../img/slide8.jpg"), require("../img/slide9.jpg"), require("../img/slide10.jpg"), require("../img/slide11.jpg"), require("../img/slide12.jpg")
			],
			large: [
				require("../img/large1.jpg"), require("../img/large2.jpg"), require("../img/large3.jpg"), require("../img/large4.jpg"), require("../img/large5.jpg"), require("../img/large6.jpg"), require("../img/large7.jpg")
			],
			flag: true,
			message: true,
			num: 0,
			envelope: true,
			ready: false,
			mySwiper: null,
			layer: false,
			largeImg:''
    	};
  	},
	props: ["activityData", "baseData"],
	computed: {
		...mapState([ "userInfo"]),
	},
	components: {
		DialogComponent,
	},
	created() {
		this.aid = this.$route.query.id || "";
  	},
  	mounted() {
	  	this.$nextTick(() => {
		  	this.preload();
			this.share();
	  	})
  	},
	methods: {
		
	  	...mapActions(["setPageLoadingAsync"]),
	  
		next() {
			switch (this.pageNum) {
				case 1:
					this.audioAutoPlay("bg_music"),
					++this.pageNum
					//this.scrollToBottom(this.$refs.myElement,1);
					break;
				case 2:
					++this.pageNum,
					this.audioAutoPause("bg_music"),
					this.audioAutoPlay("telphone1")
					break;
				case 3:
					this.audioAutoPause("bg_music"),
					this.$refs.video.pause(),
					this.audioAutoPause("telphone1");
					++this.pageNum,
					this.audioAutoPlay("bgmusic3"),
					this.audioAutoPlay("qqmusic1")
					break;
				case 4:
					this.audioAutoPause("bg_music"),
					this.audioAutoPause("bgmusic3"),
					++this.pageNum,
					this.audioAutoPlay("bgmusic4"),
					this.slide()
					break;
				default:
					//this.audioAutoPause("bgmusic4"),
					//this.audioAutoPause("bgmusic3"),
					//this.audioAutoPlay("bg_music"),
					++this.pageNum
					break;
			}
			// if (this.pageNum<4) {
			// 	++this.pageNum;
			// } else if (this.pageNum == 4) {
			// 	++this.pageNum;
			// 	if (this.mySwiper) {
			// 		this.mySwiper.destroy(false);
			// 	}
			// 	this.slide();
			// }
		},
		showLayer(i) {
			this.largeImg = this.large[i];
			this.layer = true;
		},
	  	slide() {
		  	let _this = this;
		  
		  	this.mySwiper=new Swiper('.swiper', {
				loop: false,
				direction: 'horizontal',//vertical
				//autoHeight: false,
				height: 800,
				autoplay: true,
				delay: 1000,
				pagination: { el: '.swiper-pagination', },
				on: {
					slideChange: function () {
						//console.log(this.activeIndex)
					},
				},
		  	})
	  	},
		receive() {
			this.message = false;
			this.audioAutoPlay("qqmusic2");
			let i =0,timer = 1500;
			const element = this.$refs.QQmessage;
			let objAudio = setInterval(() => {
				if(i<9){
					++i;
					this.audioAutoPlay("qqmusic2");
					element.scrollTop = element.scrollHeight;
				}else{
					clearInterval(objAudio);
				}
			}, timer);
		},
		close() {
			this.layer = false;
		},
		videoPlay() {
			this.audioAutoPause("telphone1");
			this.audioAutoPlay("telphone2");
			const video = this.$refs.video;
			let _this = this;
			if (video) {
				video.play();
				video.addEventListener('ended', function () {
					//_this.audioAutoPlay("bg_music");
					_this.next();
					console.log('视频播放结束');
				});
			}
			document.querySelector(".phone").classList.remove("animateTada");
			document.querySelector(".signal").style.display ="block";
			document.querySelector(".signal").classList.add("animateTada");
		},
		//音乐播放
		audioAutoPlay(id) {
			let audioDom = document.getElementById(id);
			if(id == "bgmusic3"){
				//console.log(audioDom.volume);
				audioDom.volume = 0.05;
			}
			audioDom.play();
		},
		//音乐停止
		audioAutoPause(id) {
			let audioDom = document.getElementById(id);
			audioDom.pause();
		},
		
		opener(){
			this.envelope = false;
			setTimeout(() => {
				this.next();
			}, 3500);
			let array = document.querySelectorAll("audio");
			array.forEach((item,i)=>{
				item.play();
				let id = item.attributes.id.nodeValue;
				setTimeout(() => {
					if(id !="bg_music"){
						item.pause();
					}
				}, 100);
			})
			
		},
		scrollToBottom(element, speed) {
		  	this.$nextTick(() => {
				if (element) {
					const h = element.scrollHeight,e =element.offsetHeight,m= h-e;
					let i = 0; 
					let scrollBehavior = setInterval(() => {
						if (i < m) {
							i += speed;
							element.scrollTop = i;
						} else {
							clearInterval(scrollBehavior);
						}
					}, 100);
					//element.scrollTop = element.scrollHeight; // 滚动到最底部
				}
		  	});
		},
		scrollHandler() {
			// const element = this.$refs.myElement;
			// console.log(element.scrollHeight, element.offsetHeight,element.scrollTop);
		},
		onTouchStart(event) {
			this.startX = event.touches[0].clientX;
			this.startY = event.touches[0].clientY;
		},
		onTouchMove(event) {
			this.endX = event.touches[0].clientX;
			this.endY = event.touches[0].clientY;
		},
		onTouchEnd() {
			const deltaX = this.endX - this.startX;
			const deltaY = this.endY - this.startY;
			
			// 判断滑动方向
			if (Math.abs(deltaX) > Math.abs(deltaY)) {
				if (deltaX > 0 ) {
					// 向右滑动
					//console.log("right");
				} else if (deltaX < 0 ) {
					// 向左滑动
					//console.log("left");
				}
			}else{
				if (deltaY > 0 ) {
					// 向下滑动
					//console.log("down");
				} else if (deltaY < 0 ) {
					// 向上滑动
					this.next();
					//console.log("up");
				}
			}
		},
	  	preload: function () {
			var that = this;
			Promise.all([
				this.reloadImg('envelope1.png'),
				this.reloadImg('envelope2.png'),
				this.reloadImg('envelope3.png'),
				this.reloadImg('logo1.png'),
				this.reloadImg('years.png'),
				this.reloadImg('wine.png'),
				this.reloadImg('titleImg.png'),
				this.reloadImg('paper.png'),
				this.reloadImg('bg1.jpg'),
				this.reloadImg('bg2.jpg'),
				this.reloadImg('bg3.jpg'),
				this.reloadImg('bg4.jpg'),
				this.reloadImg('bg5.jpg'),
				this.reloadImg('bgQQ.jpg'),
				this.reloadImg('bgRB.png'),
				this.reloadImg('film.png'),
				this.reloadImg('poster.jpg'),
				this.reloadImg('letter.png'),
				this.reloadImg('slideText.jpg'),
				this.reloadImg('phone.png'),
				this.reloadImg('message.png'),
				this.reloadImg('message1.png'),
				this.reloadImg('message2.png'),
			]).then((imgs) => {
				if (imgs.length == 23) {
					this.ready = true;
					this.setPageLoadingAsync(false);
					
				}
			})
		},
		reloadImg(imgName) {
			return new Promise((resolve, reject) => {
				let img = new Image()
				img.onload = function () {
					resolve(img);
				}
				img.src = require('../img/' + imgName);
			})
		},
		//默认分享
		share() {
			let data = this.baseData.share;
			const shareData = {
				title: data.title,
				desc: data.desc,
				imgUrl: data.imgUrl,
				link: data.link,
			};
			COVER.share(shareData);
		},
	  
  	}
};
</script>

<style lang="less" >
	
	body {
		position: fixed;
		overflow: hidden;
		bottom: 0;
		left: 0;
		right: 0;
		top: 0;
		background: #ede3d7;
	}
	.wrapper{
		width:100vw;
		 height:100%;
		 position:absolute; 
		 left:0; top:0; overflow:hidden;
	}
	.page {
		position: absolute;
		left: 0;
		top: 0;
		right: 0;
		bottom: 0;
		overflow: hidden;
		transition: all .5s;
	}
	
	.sence {
		position: relative;
	}
	.logo{
		position: absolute;
		bottom: .5rem;
		right: .5rem;
		width: 17.69%;
	}
	.cover {	
		background: url(../img/bg1.jpg) ;
		background-size: cover;
		
		.title {
			display: block;
			margin: 2rem auto .2rem 10%;
			width: 68.7%;
			animation: fadeIn 2s ease-in-out 0s backwards;
		}
		.years{
			position: absolute;
			bottom: 21.6vh;
			right: 2%;
			width: 71.94%;
			animation: heartBeat 1s linear backwards;
		}
		.wine {
			position: absolute;
			bottom: 15vh;
    		left: 21.5%;
			width: 52.5%;
		}
		.startBtn{
			position: absolute;
			top: 50%;
			left: 15.65%;
			display: block;
			width: 68.7%;
			//transform: translate(-100vh);
			animation: bounceInUp 4s linear 0s backwards;
				//animation-fill-mode: forwards;
			.closed{
				transition: all .5s;
			}
			.finger{
				position: absolute;
				bottom: 1rem;
				right: 40%;
				width: 10vw;
				animation: flash 2s ease-in-out infinite;
			}
			//animation-iteration-count: infinite;
			.opened{
				position: relative;
				.envelope3{
					width: 100%;
					transform: translateY(-1rem);
					animation: envelope3 .1s linear 0s backwards;
					// animation-fill-mode: backwards;
				}
				.paper{
					width: 80%;
					margin: auto;
					position: absolute;
					left: 10%;
					bottom: 0;
					animation: paper 1s ease-in-out 0s backwards,paper2 1s ease-in-out 1s backwards,rotateOut 3s ease-in-out 2s;
				}
				.envelope2{
					position: absolute;
					left: 0;
					bottom: 0;
					width: 100%;
				}
			}
		}
	}

	.catalogue {
		padding: 5vh 5vw 0 5vw;
		background: url(../img/bg2.jpg);
		background-size: cover;
		.scene {
			position: relative;
			top: 50%;
			left: 50%;
			transform:translate(-50%,-55%);
		}
		
		.content {
			position: relative;
			background: url(../img/paper.png);
			background-size: cover;
			height: 136vw;
			box-sizing: border-box;
			padding: 1rem;
			
			.imgBox{
				position: relative;
				height: 100%;
				overflow-y: scroll;
				
			}
			.shadow {
				position: absolute;
				bottom: .95rem;
				left: 1rem;
				right: 1rem;
				height: 1.5rem;
				background: linear-gradient(#ffffff00, #eae0d1);
			}
			.bauble {
				position: absolute;
				right: -5%;
				top: -1.5rem;
				width: 20%;
			}

			.letter {
				width: 100%;
				margin: 0 auto .8rem;
				display: block;
			}
						
		}
		
	}
	.tips {
		position: absolute;
		bottom: 0;
		left: 8.5%;
		right: 8.5%;
		height: 2rem;
		background: url(../img/tips.png) center no-repeat;
		background-size: 3vw auto;
		animation: startUp 2s ease-in-out infinite;
	}
	.tel {
		background: url(../img/bg3.jpg);
		background-size: cover;
		.content{
			width: 100%;
			height: 93.62vw;
			background: url(../img/film.png) center no-repeat;
			background-size: 100% auto;
			transform: translateY(53%);
			box-sizing: border-box;
			padding: 1.9rem 1rem;
		}
		.videoBox{
			width: 100%;
			height: 6rem;
			border-radius: 0.25rem;
			overflow: hidden;
			transform: rotate(-3deg) translateX(.15rem);
			video{
				width: 100%;
				height: 100%;
			}
		}
		.animateTada {
			animation: tada 1s linear .1s backwards infinite;
		}
		.signal {
			width: 41.02%;
			position: absolute;
			left: 5%;
    		bottom: 1.5rem;
			display: none;
		}
		.phone{
			position: absolute;
			left: 10%;
    		bottom: .5rem;
			width: 31.21%;
			z-index: 10;
		}
	}
	.tencent{
		padding: 5vh 5vw 0 5vw;
		background: url(../img/bg4.jpg);
		background-size: cover;
		.scene {
			position: relative;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -55%);
		}
		.content {
			position: relative;
			background: url(../img/bgQQ.jpg);
			background-size: cover;
			height: 110vw;
			box-sizing: border-box;
			padding: 1.9rem .3rem 2.5rem;
		}
		.qqBox {
			position: relative;
			height: 100%;
			overflow-y: scroll;
			img{
				margin-bottom: .3rem;
			}
			.message1{
				width: 45%;
				animation: messages 1s ease-in-out .2s backwards;
			}
			.message2 {
				width: 68%;
				animation: messages 1s ease-in-out 1.2s backwards;
			}
			.message3 {
				width: 96%;
				animation: messages 1.5s ease-in-out 2.2s backwards;
			}
			.message4 {
				width: 88%;
				margin-left: .2rem;
				animation: messages 1.5s ease-in-out 3.7s backwards;
			}
			.message5 {
				width: 92%;
				margin-left: .2rem;
				animation: messages 1.5s ease-in-out 5.2s backwards;
			}
			.message6 {
				width: 64%;
				margin-left: .2rem;
				animation: messages 1.5s ease-in-out 6.7s backwards;
			}

			.message7 {
				width: 68%;
				margin-left: .2rem;
				animation: messages 1.5s ease-in-out 8.2s backwards;
			}

			.message8 {
				width: 90%;
				margin-left: .2rem;
				animation: messages 1.5s ease-in-out 9.7s backwards;
			}
			.message9 {
				width: 82%;
				margin-left: .2rem;
				animation: messages 1.5s ease-in-out 11.2s backwards;
			}
			.message10 {
				width: 64%;
				margin-left: .2rem;
				margin-bottom: .5rem;
				animation: messages 1s ease-in-out 12.2s backwards;
			}
		}
	
		.shadow {
			position: absolute;
			bottom: 2.5rem;
			left: 0rem;
			right: 0rem;
			height: 0.6rem;
			background: linear-gradient(#ffffff00, #ffffff);
			
		}
		.finger1 {
			position: absolute;
			bottom: -0.5rem;
			left: 75%;
			width: 9%;
			animation: flash 3s ease-in-out infinite;
		}
	}
	.redBook{
		
		background: url(../img/bg5.jpg);
		background-size: cover;
		.scene{
			position: relative;
			bottom: 0;
			left: 0;
			width: 100%;
			height: 100%;
			animation: rollIn 1s ease-in-out 2s both;
		}
		.bgRB {
			position: absolute;;
			bottom: 0;
			left: 0;
			width: 100%;
		}
		.redContent {
			position: absolute;
			left: 1.9rem;
			right: 1.6rem;
			bottom: 2rem;
			height: 13.8rem;
			// z-index: -1;
    		border-radius: 1rem;
			background: #ffffff url(../img/slideText.jpg) no-repeat;
			background-size: 96%;
			overflow: hidden;
		}
		.swiper {
			height: 85vw;
			width: 100%;
			box-sizing: border-box;
			position: absolute;
			bottom: 3.5rem;
			left: 0;
			overflow: hidden;
			.swiper-wrapper{
				height: 80vw;
				// max-width: 90%;
				// margin: auto;
			}
			.swiper-horizontal>.swiper-pagination-bullets,
			.swiper-pagination-bullets.swiper-pagination-horizontal{
				bottom: 0;
			}
			.swiper-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet,
			.swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet{
				margin: 0 .06rem;
			}
			.swiper-pagination-bullet{
				width: .12rem;
				height: .12rem;
			}
			.swiper-pagination-bullet-active{
				background: red;
			}
			.swiper-slide{
				height: 80vw;
				overflow: hidden;
				.swiperImg {
					position: relative;
					box-sizing: border-box;
					
					height: 100%;
					
					text-align: center;
					// overflow: hidden;
					
					img{
						max-width: 100%;
					}
				}
			
				
			}
			
		}
		
	}
	.ended{
		background: url(../img/bg.jpg) ;
		background-size: cover;
		.title {
			display: block;
			margin: 3rem auto 0.2rem 8.6%;
    		width: 82.96%;
			// animation: backInLeft 1s ease-in-out ;
		}
		.years{
			position: absolute;
			bottom: 21.6vh;
			right: 2%;
			width: 71.94%;
			animation: heartBeat 1s linear backwards;
		}
		.wine {
			position: absolute;
			bottom: 15vh;
    		left: 21.5%;
			width: 52.5%;
		}
	}
	.layer{
		position: fixed;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		padding: 1rem;
		background: #00000070;
		.inner{
			position: absolute;
			top: 50%;
			left: 5%;
			right: 5%;
			transform: translateY(-50%);
			img{
				width: 100%;
			}
		}
	}
	@keyframes messages {
		0%{
			height: 0;
		}
		to {
			height: auto;
		}
	}
	@keyframes fadeIn {
		0% {
			opacity: 0
		}

		to {
			opacity: 1
		}
	}
	@keyframes backInLeft {
		0% {
			opacity: .7;
			-webkit-transform: translateX(-2000px) scale(.7);
			transform: translateX(-2000px) scale(.7)
		}

		80% {
			opacity: .7;
			-webkit-transform: translateX(0) scale(.7);
			transform: translateX(0) scale(.7)
		}

		to {
			opacity: 1;
			-webkit-transform: scale(1);
			transform: scale(1)
		}
	}
	@keyframes tada {
		0% {
			-webkit-transform: scaleX(1);
			transform: scaleX(1)
		}

		10%,
		20% {
			-webkit-transform: scale3d(.9, .9, .9) rotate(-3deg);
			transform: scale3d(.9, .9, .9) rotate(-3deg)
		}

		30%,
		50%,
		70%,
		90% {
			-webkit-transform: scale3d(1.1, 1.1, 1.1) rotate(3deg);
			transform: scale3d(1.1, 1.1, 1.1) rotate(3deg)
		}

		40%,
		60%,
		80% {
			-webkit-transform: scale3d(1.1, 1.1, 1.1) rotate(-3deg);
			transform: scale3d(1.1, 1.1, 1.1) rotate(-3deg)
		}

		to {
			-webkit-transform: scaleX(1);
			transform: scaleX(1)
		}
	}
	@keyframes rotateIn {
		0% {
			opacity: 0;
			-webkit-transform: rotate(-200deg);
			transform: rotate(-200deg)
		}

		to {
			opacity: 1;
			-webkit-transform: translateZ(0);
			transform: translateZ(0)
		}
	}
	@keyframes rotateOut {
		0% {
			z-index: 10;
			opacity: 1
		}
		to {
			z-index: 10;
			//opacity: 0.5;
			//transform: rotate(360deg) scale(3)
			transform: scale(3)
		}
	}	
	@keyframes heartBeat {
		0% {
			-webkit-transform: scale(1);
			transform: scale(1)
		}

		14% {
			-webkit-transform: scale(1.3);
			transform: scale(1.3)
		}

		28% {
			-webkit-transform: scale(1);
			transform: scale(1)
		}

		42% {
			-webkit-transform: scale(1.3);
			transform: scale(1.3)
		}

		70% {
			-webkit-transform: scale(1);
			transform: scale(1)
		}
	}
	@keyframes bounceInUp {

		0%,
		60%,
		75%,
		90%,
		to {
			-webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1);
			animation-timing-function: cubic-bezier(.215, .61, .355, 1)
		}

		0% {
			opacity: 0;
			-webkit-transform: translate3d(0, 3000px, 0) scaleY(5);
			transform: translate3d(0, 3000px, 0) scaleY(5)
		}

		60% {
			opacity: 1;
			-webkit-transform: translate3d(0, -20px, 0) scaleY(.9);
			transform: translate3d(0, -20px, 0) scaleY(.9)
		}

		75% {
			-webkit-transform: translate3d(0, 10px, 0) scaleY(.95);
			transform: translate3d(0, 10px, 0) scaleY(.95)
		}

		90% {
			-webkit-transform: translate3d(0, -5px, 0) scaleY(.985);
			transform: translate3d(0, -5px, 0) scaleY(.985)
		}

		to {
			-webkit-transform: translate(0);
			transform: translate(0)
		}
	}

	@keyframes flash {

		0%,
		50%,
		to {
			opacity: 1
		}

		25%,
		75% {
			opacity: 0
		}
	}
	@keyframes paper {
		0%{
			height: 0;
		}
		to {
			height: 8.15rem;
		}
	}
	@keyframes paper2 {
		0%{
			transform: translateY(0);
		}
		50%{
			transform: translateY(-4rem);
		}
		to {
			z-index: 10;
			transform: translateY(0);
		}
	}
	@keyframes envelope3 {
		from {
			
			transform: translateY(0)
		}
		to {
			
			transform: translateY(-1rem)
		}
	}
	@keyframes rollIn {
		0% {
			opacity: 0;
			-webkit-transform: translate3d(-100%,0,0) rotate(-120deg);
			transform: translate3d(-100%,0,0) rotate(-120deg)
		}

		to {
			opacity: 1;
			-webkit-transform: translateZ(0);
			transform: translateZ(0)
		}
	}
	@keyframes startUp {

		0%,
		30% {
			opacity: 0;
			transform: translateY(10px) rotate(180deg);
		}

		60% {
			opacity: 1;
			transform: translate(0) rotate(180deg);
		}

		to {
			opacity: 0;
			transform: translateY(-8px) rotate(180deg);
		}
	}
	@keyframes startDown {

		0%,
		30% {
			opacity: 0;
			transform: translateY(-8px)
		}

		60% {
			opacity: 1;
			transform: translate(0)
		}

		to {
			opacity: 0;
			transform: translateY(10px)
		}
	}
		
</style>